export default "__VITE_ASSET__CKNbz2pu__"